export const CATEGORIE_UNITAIRE = 'Unitaire';
export const CATEGORIE_REGROUPEMENT = 'Regroupement';
export const CATEGORIE_LOCATION = 'Location';
export const CATEGORIE_DIVERS = 'Divers';
export const CATEGORIE_IMPRESSION_AFFICHE = 'ImpressionAffiche';
export const CATEGORIE_DISPOSITIF = 'Dispositif';
export const CATEGORIE_REGROUPEMENT_NUMERIQUE = 'RegroupementNumerique';
export const CATEGORIE_REGROUPEMENT_LC = 'RegroupementLc';
export const CATEGORIE_REGROUPEMENT_MAIRIE = 'RegroupementMairie';
export const CATEGORIE_ECRAN_NUMERIQUE = 'EcranNumerique';
export const CATEGORIE_SALON = 'Salon';
export const CATEGORIE_SPONSORING = 'Sponsoring';
export const CATEGORIE_AUTRE = 'Autre';
export const CATEGORIE_PRESSE = 'Presse';
export const CATEGORIE_ENCART = 'Encart';
export const CATEGORIE_PRESTATION = 'Prestation';
export const CATEGORIE_TLPE = 'Tlpe';
export const CATEGORIE_HONORAIRE = 'Honoraire';

export const RESEAU_TEMPO = 'Tempo';
export const RESEAU_LC = 'Lc';
export const RESEAU_ECRAN_NUMERIQUE = 'Ecran';
export const MAIRIE = 'Mairie';

export const TYPE_EDITION_RESEAU = 'ProduitReseau';
export const TYPE_EDITION_RESEAU_LC = 'ProduitReseauLc';
export const TYPE_EDITION_FACE = 'ProduitFace';
export const TYPE_EDITION_PLANNING_RESEAU = 'PlanningProduitReseau';
export const TYPE_EDITION_ECRAN = 'ProduitEcranNumerique';

export const AFFECTATION_RESEAU = 'Reseau';
export const AFFECTATION_LC = 'Commande';

export const TYPE_EDITION_FACE_CATALOGUE = 'FaceCatalogue';
export const TYPE_EDITION_FACE_PATRIMOINE = 'FacePatrimoine';
export const TYPE_EDITION_PLANNING_RESEAU_TEMPO_LC_REGIE_MEDIA = 'PlanningReseauxTempoLcRegieMedia';

export const CATEGORIES_RESEAU = [
  { code: RESEAU_LC, libelle: 'catalogue.newProduct.category.Lc' },
  { code: RESEAU_TEMPO, libelle: 'catalogue.newProduct.category.Tempo' },
  { code: RESEAU_ECRAN_NUMERIQUE, libelle: 'catalogue.newProduct.category.ecran' },
];

/**
 * CATEGORIE_PRODUIT est la liste des produits de base sur Affixe
 * Cette liste sers de base pour les comportement front
 * Cette liste est filtrer par rapport au module active dans le store categorieVente
 * Il est préférable d'utiliser le store.
 */
export const CATEGORIE_PRODUIT = [
  {
    code: CATEGORIE_UNITAIRE,
    libelle: 'catalogue.type.face',
    routeDetail: 'c.bodac.catalogue-face',
    routeModif: 'm.bodac.catalogue-editionFace',
    menu: {
      route: 'l.bodac.catalogue-face',
      libelle: 'sidebar.gestCom.face',
      ordre: 4,
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_LOCATION,
    libelle: 'catalogue.type.bothLocation',
    numerique: {
      libelle: 'catalogue.type.locationNumerique',
      routeDetail: 'c.bodac.catalogue-locationNumerique',
      routeModif: 'm.bodac.catalogue-editionLocationNumerique',
    },
    nonNumerique: {
      libelle: 'catalogue.type.location',
      routeDetail: 'c.bodac.catalogue-location',
      routeModif: 'm.bodac.catalogue-editionLocation',
    },
    patrimonial: false,
  },
  {
    code: CATEGORIE_DIVERS,
    libelle: 'catalogue.type.divers',
    routeDetail: 'c.bodac.catalogue-divers',
    routeModif: 'm.bodac.catalogue-editionDivers',
    patrimonial: false,
  },
  {
    code: CATEGORIE_REGROUPEMENT,
    libelle: 'catalogue.type.reseauTempo',
    routeDetail: 'c.bodac.catalogue-reseau',
    routeModif: 'm.bodac.catalogue-editionReseau',
    menu: {
      route: 'l.bodac.catalogue-reseauTempo',
      libelle: 'sidebar.gestCom.reseauTempo',
      ordre: 1,
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_REGROUPEMENT_LC,
    libelle: 'catalogue.type.reseauLc',
    routeDetail: 'c.bodac.catalogue-reseauLc',
    routeModif: 'm.bodac.catalogue-editionReseauLc',
    menu: {
      route: 'l.bodac.catalogue-reseauLc',
      libelle: 'sidebar.gestCom.reseauLc',
      ordre: 2,
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_REGROUPEMENT_MAIRIE,
    libelle: 'catalogue.type.reseauMairie',
    routeDetail: 'c.bodac.catalogue-reseauMairie',
    routeModif: 'm.bodac.catalogue-editionReseauMairie',
    menu: {
      route: 'l.bodac.catalogue-reseauMairie',
      libelle: 'sidebar.gestCom.reseauMairie',
      ordre: 3,
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_REGROUPEMENT_NUMERIQUE,
    libelle: 'catalogue.type.reseauNumerique',
    routeDetail: 'c.bodac.catalogue-reseauNumerique',
    routeModif: 'm.bodac.catalogue-editionReseauNumerique',
    menu: {
      route: 'l.bodac.catalogue-reseauNumerique',
      libelle: 'sidebar.gestCom.reseauNum',
      ordre: 9,
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_ECRAN_NUMERIQUE,
    libelle: 'catalogue.type.numerique',
    routeDetail: 'c.bodac.catalogue-ecranNumerique',
    routeModif: 'm.bodac.catalogue-editionNumerique',
    menu: {
      route: 'l.bodac.catalogue-ecran',
      libelle: 'sidebar.gestCom.ecranNum',
      ordre: 8,
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_SALON,
    libelle: 'catalogue.type.salon',
    routeDetail: 'c.bodac.catalogue-detailSalon',
    routeModif: 'm.bodac.catalogue-editionSalon',
    menu: {
      route: 'l.bodac.catalogue-salon',
      libelle: 'sidebar.gestCom.salon',
      ordre: 5,
      params: { typeProduit: CATEGORIE_SALON },
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_SPONSORING,
    libelle: 'catalogue.type.sponsoring',
    routeDetail: 'c.bodac.catalogue-detailSponsoring',
    routeModif: 'm.bodac.catalogue-editionSponsoring',
    menu: {
      route: 'l.bodac.catalogue-produitsModulePresse',
      libelle: 'sidebar.gestCom.sponsoring',
      ordre: 7,
      params: { typeProduit: CATEGORIE_SPONSORING },
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_AUTRE,
    libelle: 'catalogue.type.autre',
    routeDetail: 'c.bodac.catalogue-detailAutre',
    routeModif: 'm.bodac.catalogue-editionAutre',
    patrimonial: true,
    menu: {
      route: 'l.bodac.catalogue-produitsModulePresse',
      libelle: 'sidebar.gestCom.autre',
      ordre: 7,
      params: { typeProduit: CATEGORIE_AUTRE },
    },
  },
  {
    code: CATEGORIE_PRESSE,
    libelle: 'catalogue.type.presse',
    routeDetail: 'c.bodac.catalogue-detailPresse',
    routeModif: 'm.bodac.catalogue-editionPresse',
    menu: {
      route: 'l.bodac.catalogue-produitPresse',
      libelle: 'sidebar.gestCom.presse',
      ordre: 6,
      params: { typeProduit: CATEGORIE_PRESSE },
    },
    patrimonial: true,
  },
  {
    code: CATEGORIE_ENCART,
    libelle: 'catalogue.type.encart',
    routeDetail: '',
    routeModif: '',
    patrimonial: false,
  },
  {
    code: CATEGORIE_PRESTATION,
    libelle: 'catalogue.type.prestation',
    routeDetail: '',
    routeModif: '',
    patrimonial: false,
  },
  {
    code: CATEGORIE_DISPOSITIF,
    libelle: 'catalogue.type.dispositif',
    routeDetail: 'c.bodac.catalogue-dispositif',
    routeModif: 'm.bodac.catalogue-editionDispositif',
    patrimonial: false,
  },
];

export const CATEGORIE_PRODUIT_ACHAT = [
  {
    code: CATEGORIE_DIVERS,
    libelle: 'catalogue.type.divers',
    routeDetail: 'c.bodac.catalogue-divers',
    routeModif: 'm.bodac.catalogue-editionDivers',
  },
  {
    code: CATEGORIE_IMPRESSION_AFFICHE,
    libelle: 'catalogue.type.impressionAffiche',
    routeDetail: 'c.bodac.catalogue-impressionAffiche',
    routeModif: 'm.bodac.catalogue-editionProduitImpressionAffiche',
  },
];

export const CATEGORIE_PRODUIT_INDEXABLE = [
  {
    code: CATEGORIE_DIVERS,
    libelle: 'catalogue.type.divers',
  },
  {
    code: CATEGORIE_TLPE,
    libelle: 'catalogue.type.tlpe',
  },
  {
    code: CATEGORIE_ENCART,
    libelle: 'catalogue.type.encart',
  },
  {
    code: CATEGORIE_PRESTATION,
    libelle: 'catalogue.type.prestation',
  },
  {
    code: CATEGORIE_HONORAIRE,
    libelle: 'catalogue.type.honoraire',
  },
  {
    code: CATEGORIE_LOCATION,
    libelle: 'catalogue.type.bothLocation',
  },
];

export const EXPORT_EXCEL_PRODUIT_FACE = 'produitsface';
export const EXPORT_EXCEL_OBJECTIF_RESEAU_TEMPO_PRODUIT = 'objectifsreseauxtempo';
export const EXPORT_EXCEL_PRODUIT_RESEAU_TEMPO = 'produitsreseauxtempo';
export const EXPORT_EXCEL_PRODUIT_RESEAU_NUMERIQUE = 'produitsreseauxnumerique';
export const EXPORT_EXCEL_PRODUIT_ECRAN = 'produitsecrannumerique';

export const LISTE_AZIMUT_RECHERCHE = [
  {
    code: '0',
    class: 'puce azimut0',
  },
  {
    code: '30',
    class: 'puce azimut30',
  },
  {
    code: '60',
    class: 'puce azimut60',
  },
  {
    code: '90',
    class: 'puce azimut90',
  },
  {
    code: '120',
    class: 'puce azimut120',
  },
  {
    code: '150',
    class: 'puce azimut150',
  },
  {
    code: '180',
    min: 165,
    max: 194,
    class: 'puce azimut180',
  },
  {
    code: '210',
    class: 'puce azimut210',
  },
  {
    code: '240',
    class: 'puce azimut240',
  },
  {
    code: '270',
    class: 'puce azimut270',
  },
  {
    code: '300',
    class: 'puce azimut300',
  },
  {
    code: '330',
    class: 'puce azimut330',
  },
];

export const EDITION_RESEAU_SANS_CARTO = 'ReseauSansCarto';
export const LISTE_CHOICE_EDITION_FACE_UNITAIRE = [
  { typeEdition: '', libelle: 'catalogue.edition.face', typeDonnee: TYPE_EDITION_FACE },
];
export const LISTE_CHOICE_EDITION_ECRAN_NUMERIQUE = [
  { typeEdition: '', libelle: 'catalogue.edition.ecranNumerique', typeDonnee: TYPE_EDITION_ECRAN },
];

export const LISTE_CHOICE_EDITION_FACE_PATRIMOINE = [
  { typeEdition: TYPE_EDITION_FACE_PATRIMOINE, libelle: 'catalogue.edition.face', typeDonnee: TYPE_EDITION_FACE },
];

export const LISTE_CHOICE_EDITION_RESEAU = [
  { typeEdition: '', libelle: 'catalogue.edition.reseau', typeDonnee: TYPE_EDITION_RESEAU },
  { typeEdition: '', libelle: 'catalogue.edition.diaporama', typeDonnee: 'Diaporama' },
  { typeEdition: EDITION_RESEAU_SANS_CARTO, libelle: 'catalogue.edition.reseauSansCarto', typeDonnee: TYPE_EDITION_RESEAU },
];
export const LISTE_CHOICE_EDITION_RESEAU_LC = [
  { typeEdition: '', libelle: 'catalogue.edition.reseau', typeDonnee: TYPE_EDITION_RESEAU_LC },
  { typeEdition: '', libelle: 'catalogue.edition.diaporama', typeDonnee: 'Diaporama' },
  { typeEdition: EDITION_RESEAU_SANS_CARTO, libelle: 'catalogue.edition.reseauSansCarto', typeDonnee: TYPE_EDITION_RESEAU_LC },
];

export const ACTION_DIAPORAMA = 'diaporama';

export const TYPE_DONNEE_DIAPORAMA = 'Diaporama';
export const TYPE_SOURCE_DIAPORAMA = 'faces';
export const ACTION_PLANNING_RESEAU_TEMPO = 'planning reseau tempo';
export const ACTION_EXPORT_FACES_RESEAU_TEMPO = 'listeProduitReseauTempo.actions.exporterFacesReseaux';

export const PRODUITS_PRESSE_INFOS = {
  [CATEGORIE_PRESSE]: {
    routeCreation: 'm.bodac.catalogue-nouveauPresse',
  },
  [CATEGORIE_SPONSORING]: {
    routeCreation: 'm.bodac.catalogue-nouveauSponsoring',
  },
  [CATEGORIE_SALON]: {
    routeCreation: 'm.bodac.catalogue-nouveauSalon',
  },
  [CATEGORIE_AUTRE]: {
    routeCreation: 'm.bodac.catalogue-nouveauAutre',
  },
};

export const ACTION_MODIFIER_DATE_DEBUT = 'modifierDateDebut';
export const ACTION_MODIFIER_DATE_FIN = 'modifierDateFin';

export const LIVRAISON_DE_BIEN = 'LivraisonDeBien';
export const FOURNITURE_DE_SERVICE = 'FournitureDeService';
export const CATEGORIE_OPERATION = [
  {
    code: LIVRAISON_DE_BIEN,
    libelle: 'catalogue.categorieOperation.livraisonDeBien',
  },
  {
    code: FOURNITURE_DE_SERVICE,
    libelle: 'catalogue.categorieOperation.fournitureDeService',
  },
];

export const PRODUITS_ASSOCIES_COMPONENT_NAME = 'produits-associes';
export const EXPORT_EXCEL_PRODUIT_PRESSE = 'produitsmodulepresse';

export const FACES_RESEAUX_SELECTIONEES = 'facereseauxselectiones';

export const FACE_TYPE_IMPACT_VENTE = 'Vente';
export const FACE_TYPE_IMPACT_LOGISTIQUE = 'Logistique';

export const EXPORT_EXCEL_RESEAU_FACES_IMPACT = 'reseaufacesimpact';
